import { render, staticRenderFns } from "./CollectionWidgetEdit.vue?vue&type=template&id=5faffe2f"
import script from "./CollectionWidgetEdit.vue?vue&type=script&lang=js"
export * from "./CollectionWidgetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports